angular.module('rjmNg.api').factory("Tables", [
  "$q"
  "app"
  "modelFactory"
  "serviceUrl"
  (
    $q
    app
    modelFactory
    serviceUrl
  ) ->

    options =
      httpConfig:
        withCredentials: true
      cacheOptions:
        deleteOnExpire: 'passive'
        maxAge: (60*60*1000) # one hour

    Tables = modelFactory serviceUrl("/clients/#{app.getClientId()}/tables"), options

    # Looks at list of tables, creates an array of unique database names
    Tables.getDatabases = (tables) ->
      databases = []
      addDb = (db) ->
        if !_.findWhere(databases, {name: db})
          databases.push({name: db, expanded: true})
      angular.forEach(tables, (table) ->
        if table.type is "consolidated"
          addDb "Consolidated Tables"
        else if table.type is "view"
          addDb "Data Warehouse Views"
        else if table.remote_table
          addDb table.remote_table.database
      )
      return databases

    Tables.setName = (table, name) ->
      deferred = $q.defer()
      Tables.query(state: ["active"]).then(
        (tables) ->
          if _.some(tables, (t) -> t.id isnt table.id and t.name.toLowerCase() is name.toLowerCase())
            deferred.reject(errorMessage: "Name <strong>#{name}</strong> has already been taken. Name must be unique (case insensitive).")
          else
            Tables.save(id: table.id, name: name).then(
              (savedTable) ->
                deferred.resolve(savedTable)
              , (error) ->
                deferred.reject(error)
            )
        , (error) ->
          deferred.reject(error)
      )

      return deferred.promise


    return Tables
  ]
)
